module.exports = __webpack_public_path__ + "media/images/PHI-Summer-Interns-516c278319c9beffaea82f0bc19244a6.jpeg";